import { createSelector } from 'reselect';

import { EditorSelectedQuery } from '@mode/legacy/types-app-state';

import { AppState } from '@mode/legacy/types-app-state';
import { WorkspaceView } from '@mode/legacy/types-app-state';
import { SelectedReportSelectors } from './selected-report.selectors';
import { fromChartSelectors } from '@mode/charts/domain';

export namespace WorkspaceSelectors {
  export const getEditorSidebarEnabled = (state: AppState) => state.workspace.editorSidebarEnabled;
  export const getWorkspaceView = (state: AppState) => state.workspace.workspaceView;
  export const showSqlEditor = createSelector(getWorkspaceView, (view) => view === WorkspaceView.SqlEditor);
  export const showChartBuilder = createSelector(
    getWorkspaceView,
    (view) => view === WorkspaceView.Chart // todo: change to WorkspaceView.ChartBuilder
  );
  export const showReportBuilder = createSelector(getWorkspaceView, (view) => view === WorkspaceView.ReportBuilder);
  export const showDisplayTable = createSelector(getWorkspaceView, (view) => view === WorkspaceView.DisplayTable);
  export const showNotebook = createSelector(getWorkspaceView, (view) => view === WorkspaceView.Notebook);

  export const getEditorSelectedQuery = createSelector(
    (state: AppState) => state.reportEditor.selectedQueryToken,
    SelectedReportSelectors.getQueries,
    SelectedReportSelectors.getTables,
    fromChartSelectors.selectResources,
    SelectedReportSelectors.getChartTokensByQueryMap,
    (queryToken, queries, tables, charts, chartsByQuery): EditorSelectedQuery => ({
      name: queries.getRecord(queryToken)?.name,
      token: queryToken,
      last_run_id: queries.getRecord(queryToken)?.resource?.last_run_id,
      storedCharts: chartsByQuery.has(queryToken)
        ? chartsByQuery
            .get(queryToken)
            .map((token) => charts.get(token))
            .toArray()
        : [],
      storedTables: tables
        .getRecords()
        .filter((t) => t.queryToken === queryToken)
        .map((t) => t.resource),
    })
  );
}
